import { defineComponent } from "vue";

/**
 * 渲染 `Gps` SVG 图标。
 *
 * @remarks
 * Vue 透传属性（如 `class`、`style`、`role`、`aria-label`、`width`、`height` 和 `fill`）会应用到根 `<svg>` 元素。
 */
export const Gps = defineComponent({
	name: "Gps",
	render() {
		return (
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
				<path d="M555.63636406 651.63636406c48-52.36363594 48-130.90909125-2.18181843-181.09090968s-130.90909125-50.18181844-181.09090969-2.18181844l-174.54545438-174.54545438c-21.81818156-21.81818156-54.54545437-15.27272719-69.81818156 10.90909125-89.45454563 165.81818156-65.45454562 377.45454562 74.18181844 517.09090875 139.63636406 139.63636406 351.27272719 163.63636406 517.09090875 74.18181844 26.18181844-13.09090875 30.54545437-48 10.90909125-69.81818156l-174.54545438-174.54545438zM512 75.63636406c-65.45454562 0-128.72727281 15.27272719-185.45454563 41.45454469l28.36363688 58.90909125C402.90909125 154.18181844 455.27272719 141.09090875 512 141.09090875c205.09090875 0 370.90909125 165.81818156 370.90909125 370.90909125 0 56.72727281-13.09090875 109.09090875-34.90909125 157.09090875l58.90909125 28.36363688C933.09090875 640.72727281 948.36363594 577.45454562 948.36363594 512c0-240-196.36363594-436.36363594-436.36363594-436.36363594z" />
				<path d="M512 250.18181844c-39.27272719 0-78.54545438 8.72727281-113.45454562 26.1818175l28.36363687 58.90909125c26.18181844-13.09090875 54.54545437-19.63636406 85.09090875-19.63636313 109.09090875 0 196.36363594 87.27272719 196.36363594 196.36363594 0 30.54545437-6.54545437 58.90909125-19.63636313 85.09090875l58.90909125 28.36363688c15.27272719-34.90909125 26.18181844-72 26.1818175-111.27272719C773.81818156 368 656 250.18181844 512 250.18181844z" />
			</svg>
		);
	},
});

export default Gps;
